<script>
    import { inventoryMethods, warehouseMethods, pendingsMethods, productsReportMethods, inventoryReportsMethods } from '@state/helpers'
    import { mapGetters } from 'vuex'
    
    export default {
      name: 'Title',
      components: {},
      data() {
        return {
            orderOK: false,
            noOrder: false,
            showEmailModal: false,
            sendingOrder: false,
            emails: JSON.parse(window.localStorage.getItem('emails')) || [],
            subject: 'Pedido',
            message: '',
            inventorySaved:false,
            loadingSave:false,
            loadingFinish:false,
            CancelModalShow:false,
            FinishModalShow:false,
            isSubmitting:false,
        }
      },
      computed: {
        ...mapGetters({
          own_warehouse_i: 'retina/inventory/own_warehouse_i',
          own_inventory_count_mode: 'retina/inventory/own_inventory_count_mode',
          loading_inventory: 'retina/inventory/loading_inventory',
          own_pending: 'retina/inventory/own_pending',
          own_stock: 'retina/inventory/own_stock',
          own_inventory: 'retina/inventory/own_inventory',
        }),
      },
      mounted() {
        this.subject = '(' + new Date(Date.now()).toLocaleDateString() + ') Pedido'
        this.message = 'Buen día,\n\nSe adjunta el pedido actual'
        this.message += '\n\nCualquier duda comuníquese con su asesor comercial.\n\nPor favor no responder a este correo.'
      },
      methods: {
        ...inventoryMethods,
        ...warehouseMethods,
        ...pendingsMethods,
        ...productsReportMethods,
        ...inventoryReportsMethods,
        validator(tag) {
          let exr = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
          let validEmail = exr.test(tag)
          // const required = (val) => val && val.length;
          return validEmail
        },
        finishOwnInventoryProcess() {
          let context = this
          context.loadingFinish=true
          let content={
            own_warehouse_i:this.own_warehouse_i,
            items:this.own_stock,
            user:JSON.parse(window.localStorage.getItem('auth.currentSession')).user.email
          }
          const promise = this.finishOwnInventory(content)
          return promise
            .then((data) => {
              this.$generate_toast(this, 'success', `Inventario finalizado`)
              setTimeout(() => {
                context.loadingFinish=false
                context.reset()
                return data
              }, 2000)
              
            })
            .catch((error) => {
              this.$axios_error_noty(error, this)
              console.log(error)
              return []
            })
        },
        saveOwnInventoryProcess() {
          if(this.own_stock.length>0){
            let context = this
            context.loadingSave=true
            let content={
              own_warehouse_i:this.own_warehouse_i,
              items:this.own_stock,
            }
            const promise = this.saveOwnInventory(content)
            return promise
              .then((data) => {
                context.inventorySaved=true
                context.loadingSave=false
                return data
              })
              .catch((error) => {
                this.$axios_error_noty(error, this)
                console.log(error)
                return []
              })
          } else{
            this.$generate_toast(this, 'warn', `Para guardar debe existir al menos un item en el conteo.`);
          }
        },
        closeInventoryCountMode() {
          this.clearOwnInventory()
          this.setOwnTotalProducts(0)
          this.setOwnTotalProductsQuantity(0)
          this.clearOwnStock()
          this.setOwnTotalStock(0)
          this.setOwnTotalStockQuantity(0)
          this.clearOwnPending()
          this.setOwnTotalPending(0)
          this.disableOwnInventoryCountMode()
          this.setConsultWarehouse(true)
        },
        async reset() {
          if(this.restorePendings === true){
            this.deletePendings()
          }
          this.$store.dispatch('retina/warehouse/clearOwnWarehouse')
          this.setOwnWarehouseI(null)
          this.enableOwnInventoryCountMode()
          this.clearOwnInventory()
          this.setOwnStock([])
          this.clearOwnPending()
          this.setOwnTotalPending(0)
          this.disableOwnInventoryCountMode()
          this.setOwnInventoryOnlineMode(false)
          this.setOwnInventoryCountReview(false)
          this.setConsultWarehouse(true)
        },
        async proccessSendOrder() {
          console.info("start proccessSendOrder()")
          this.orderOK = false
          this.orderError = false
          this.sendingOrder = true
          this.modalShow = true
          this.orderErrorMessage = ''
    
          // definición del nuevo objecto para envío de email de los resultados del conteo:
          let email_data = {}
          if(this.emails.length > 0){
            email_data = {
              To_emails: this.emails,
              subject: this.subject,
              message: this.message,
              warehouse: this.own_warehouse_i.description,
            }
            window.localStorage.setItem('emails', JSON.stringify(this.emails))
            this.showEmailModal = false
          }
          console.info("mails.length? ", this.emails.length)
    
          try {
            console.info("before sendPendingProducts()")
            await this.sendPendingProducts()
            console.log("passed sendPendingProducts()")
          } catch(error){
            console.error("Error on sendPendingProducts()", error)
            this.$generate_toast(this, 'error', 'Ocurrió un error preparando la orden, reintente nuevamente')
            this.orderError = true
            this.sendingOrder = false
            await this.errorToMessage(error)
            return 
          }
    
          this.order = {}
          this.order.order_uuid = 'c8da3bfe-40cc-451c-b2b4-00958dacef37' // ! hace referencia al uuid del conector de ordenes en base de datos ... uuid -> unico
          this.order.commitment_uuid = '8bf47cc4-6b83-4a60-a758-0967bb7d1fc6' // ! hace referencia al uuid del conector de compromisos en base de datos ... uuid -> unico
          this.order.nit = '001'
          this.order.id_co = '001'
          this.order.subsidiary = '001'
          this.order.warehouse = this.own_warehouse_i.code
          this.order.location = '001'
          this.order.pay_condition = '001'
          this.order.id_price = '001'
          this.order.email = email_data
    
          console.log("before sendOrder(). Keys: ", Object.keys(this.order).length, 'Items:', this.order.items.length)
          this.sendOrder(this.order)
            .then(async(data) => {
              console.log("sendOrder.then(data)", data)
              this.sendingOrder = false
              this.orderNumber = data
              this.orderOK = true
              this.orderErrorMessage = null
            })
            .catch(async(error) => {
              console.error("sendOrder.catch(error)", error)
              this.orderNumber = null
              this.sendingOrder = false
              this.orderError = true
              await this.errorToMessage(error)
              if (this.emails.length === 0){
                this.orderErrorMessage += '<br><br><b>Te recomendamos que finalices enviando el resultado del pedido por email</b>'
              }
            })
        },
      },
    }
    </script>
    <template>
      <b-card v-if="own_inventory_count_mode" no-body class="p-2">
        <span class="text-primary font-weight-lighter">Lugar seleccionado:</span>
        <b-card-title>{{ own_warehouse_i.description }}</b-card-title>
        <b-card-sub-title class="mb-2 lead">
          <b-badge variant="primary">{{ own_warehouse_i.code }}</b-badge>
        </b-card-sub-title>
        <b-card-footer footer-bg-variant="transparent" footer-class="p-0 d-flex justify-content-between">
            <b-button-group class="w-100">
              <b-button
                @click="CancelModalShow=true"
                variant="outline-danger"
                class="mr-1"
              >
                <i class="fas fa-times"></i> Cancelar
              </b-button>
              <b-button
                @click="saveOwnInventoryProcess()"
                variant="outline-info"
                class="mr-1"
              >
                <div v-if="!loadingSave">
                  <i class="fas fa-save"></i> Guardar
                </div>
                <span
                    v-if="loadingSave"
                    class="spinner-border spinner-border-sm"
                    role="status"
                  >
                </span>
                <span v-if="loadingSave"> Cargando ... </span>
              </b-button>
              <b-button v-if="inventorySaved"
                @click="FinishModalShow=true"
                variant="outline-success"
                class="mr-1"
              >
                <div v-if="!loadingFinish">
                  Finalizar inventario<i class="fas fa-share ml-1"></i>
                </div>
                <span
                    v-if="loadingFinish"
                    class="spinner-border spinner-border-sm"
                    role="status"
                  >
                </span>
                <span v-if="loadingFinish"> Cargando ... </span>
              </b-button>
          </b-button-group>
        </b-card-footer>
        <!--Cancelar-->
        <b-modal
          id="cancel-modal"
          v-model="CancelModalShow"
          title="Cancelar Inventario"
          ok-title="Cancelar"
          ok-variant="danger"
          @hidden="CancelModalShow=false"
          @ok="closeInventoryCountMode"
          @cancel="CancelModalShow=false"
        >
          <p>
            ¿Esta seguro de cancelar el Inventario? Los cambios realizados no se guardaran.
          </p>
          <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="secondary" @click="cancel">
              Cerrar
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              :disabled="isSubmitting"
              @click="ok"
            >
              <span v-if="!isSubmitting">
                Cancelar
              </span>
              <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
              </b-spinner>
            </b-button>
          </template>
        </b-modal>
        <!--Finalizar-->
        <b-modal
          id="finish-modal"
          v-model="FinishModalShow"
          title="Finalizar Inventario"
          ok-title="Finalizar"
          ok-variant="success"
          @hidden="FinishModalShow=false"
          @ok="finishOwnInventoryProcess"
          @cancel="FinishModalShow=false"
        >
          <p>
            ¿Esta seguro de finalizar el Inventario? De ser así no podrá agregar mas items.
          </p>
          <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="secondary" @click="cancel">
              Cerrar
            </b-button>
            <b-button
              size="sm"
              variant="success"
              :disabled="loadingSave"
              @click="ok"
            >
              <span v-if="!loadingSave">
                Finalizar
              </span>
              <b-spinner v-if="loadingSave" small label="Spinning" variant="light">
              </b-spinner>
            </b-button>
          </template>
        </b-modal>
      </b-card>
    </template>
    